// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputCheckbox from '@/components/input/modules/checkbox'

// vuex
import { mapState } from 'vuex'

/**
 * @module
 * @name AdminView
 * @description Inner layout used to render a tab view.
 */
export default {
  name: 'AdminView',
  /**
   * @property {Object} table Object which contains all the info to render as
   *  a table.
   * @property {Number} currentPage Current page number.
   * @property {Number} totalPages Total number pages.
   * @property {String} filterWarrantyId Warranty id.
   * @property {String} filterSubwarrantyId Subwarranty i
   */
  data: function () {
    return {
      table: null,
      currentPage: 1,
      totalPages: 0,
      filterWarrantyId: null,
      filterSubwarrantyId: null
    }
  },
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputCheckbox
  },
  /**
   * @property {Boolean} canEdit Returns true if the user is admin or company admin.
   * @property {Boolean} hasData Returns true if this.table has contennt. This
   *  content is got from backend.
   */
  computed: {
    ...mapState({
      stateUserRole: state => state.user.role || null
    }),
    canEdit: function () {
      return this.stateUserIsSuperAdmin || this.stateUserIsCompanyAdmin
    },
    hasData: function () {
      return this.table && this.table.length > 0
    }
  },

  methods: {
    /**
     * @function
     * @name handleFiltersChange
     * @param {Object} filters Object which contains warranty and subwarranty ids.
     * @param {String} filters.warranty Warranty id.
     * @param {String} filters.subwarranty Subwarranty id.
     */
    handleFiltersChange: function (filters) {
      this.filterWarrantyId = filters.warranty
      this.filterSubwarrantyId = filters.subwarranty
      this.currentPage = 1
      this.handleSearch()
    },

    /**
     * @function
     * @name handlePageUpdate
     * @param {Number} page Target page.
     * @description Set current page, then trigger search.
     */
    handlePageUpdate: function (page) {
      this.currentPage = page
      this.handleSearch()
    },

    /**
     * @function
     * @name handlePageSet
     * @param {Number} page Target page.
     * @description Set current page.
     */
    handlePageSet: function (page) {
      this.currentPage = page
    },

    /**
     * @function
     * @name handleCancel
     * @description Reset edit values and hides modal.
     */
    handleCancel: function () {
      this.resetEditValues()
      this.$refs.adminEditModal.showModal = false
    },

    /**
     * @function
     * @name handleSearch
     * @description Request filtered table data for each view.
     */
    handleSearch: function () {},

    /**
     * @function
     * @name handleEdit
     * @description Set current tab local state object with clicked item
     *  properties and shows modal.
     */
    handleEdit: function () {},

    /**
     * @function
     * @name resetEditValues
     * @description Request filtered table data for each view.
     */
    resetEditValues: function () {},

    /**
     * @function
     * @name handleSave
     * @description Patch information
     */
    handleSave: function () {}
  },

  /**
   * @function
   * @name mounted
   * @description Initial search.
   */
  mounted: function () {
    this.handleSearch()
  }
}
